import { createThunk } from 'utils/createThunk';
import * as backendAPI from 'api/backendAPI/models';
import types from 'constants/actionTypes';

export const fetchModelCompetition = createThunk({
  apiCall: backendAPI.getModelCompetition,
  type: types.GET_MODEL_COMPETITION_REQUEST,
});

export const clearModelCompetitionData = () => ({
  type: types.CLEAR_MODEL_COMPETITION_DATA,
});
